import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileUploadModule } from 'ng2-file-upload';
import { ColorPickerModule } from 'ngx-color-picker';
import {
  MatButtonToggleModule,
  MatDialogModule,
  MatAutocompleteModule,
  MatCardModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatSliderModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatTabsModule,
  MatIconModule,
  MatButtonModule,
  MatGridListModule,
  MatSidenavModule,
  MatToolbarModule,
  MatInputModule
} from '@angular/material';
import { FormGeneratorComponent } from './form-generator/form-generator.component';
import { FormElementComponent } from './form-element/form-element.component';
import {
  FormGroupDef,
  FormTemplateDef,
  FormDividerDef,
  DefaultFormTemplateDef,
  DefaultFormGroupDef,
  DefaultFormDividerDef
} from './templates';
import { FormPlaceholder, InjectionPlaceholder } from './internal-templates';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FileUploadModule,
    ColorPickerModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatSliderModule,
    MatSelectModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatInputModule,
    MatSlideToggleModule
  ],
  declarations: [
    FormGeneratorComponent,
    FormElementComponent,
    FormGroupDef,
    FormTemplateDef,
    FormPlaceholder,
    FormDividerDef,
    InjectionPlaceholder,
    DefaultFormTemplateDef,
    DefaultFormGroupDef,
    DefaultFormDividerDef
  ],
  exports: [
    FormGeneratorComponent,
    FormElementComponent,
    FormTemplateDef,
    FormGroupDef,
    FormDividerDef
  ]
})
export class NgxFormGeneratorModule {}
